import * as appSchema from "./app-schema"
import * as authSchema from "./auth-schema"
import * as bomSchema from "./bom-schema"
import * as changeProjectSchema from "./change-project-schema"
import * as evaluationSchema from "./evaluation-schema"
import * as featureFlagsSchema from "./feature-flags-schema"
import * as phase2ConfigSchema from "./phase2-config-schema"
import * as relations from "./relations"
import * as storeConfigSchema from "./store-configuration-schema"

export const schema = {
  ...authSchema,
  ...appSchema,
  ...storeConfigSchema,
  ...phase2ConfigSchema,
  ...featureFlagsSchema,
  ...changeProjectSchema,
  ...bomSchema,
  ...evaluationSchema,
  ...relations,
}

export * from "./auth-schema"
export * from "./app-schema"
export * from "./store-configuration-schema"
export * from "./phase2-config-schema"
export * from "./feature-flags-schema"
export * from "./change-project-schema"
export * from "./bom-schema"
export * from "./evaluation-schema"
export * from "./relations"
